import type { QueryClient } from "@tanstack/vue-query";

export function invalidateBillingQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ["billing"] });
  queryClient.invalidateQueries({ queryKey: ["organizationSubscriptionStatus"] });
}

export function invalidateBillingQueriesWithDelay(queryClient: QueryClient, delayMs = 4000) {
  invalidateBillingQueries(queryClient);
  // Delayed re-invalidation for webhook-created invoices
  setTimeout(() => {
    queryClient.invalidateQueries({ queryKey: ["billing", "invoices"] });
    queryClient.invalidateQueries({ queryKey: ["billing", "billingEstimate"] });
  }, delayMs);
}
